/** The player's ranger, one tick: timers, then movement, weapons and hand actions (02 §4-§8). */

import type { Ctx } from '../ctx';
import { RANGER } from '../tuning';
import { stepActions } from './actions';
import { stepMovement } from './movement';
import { stepWeapons } from './weapons';

export { interactOption, type InteractOption } from './actions';
export { carriedWeight } from './movement';
export { isAware, knifeTarget } from './knife';

export function stepRanger(ctx: Ctx): void {
  const { world: w, cmd } = ctx;
  const r = w.ranger;
  r.prevX = r.x;
  r.prevZ = r.z;
  r.sinceShot++;
  if (r.fireCooldown > 0) r.fireCooldown--;
  if (r.staggerTicks > 0) r.staggerTicks--;
  for (let i = r.recentHits.length - 1; i >= 0; i--) {
    const age = (r.recentHits[i] ?? 0) + 1;
    if (age > RANGER.recentHitWindow) r.recentHits.splice(i, 1);
    else r.recentHits[i] = age;
  }

  const controllable = r.status === 'active' || r.status === 'downed' || r.status === 'boarding';
  if (!controllable) {
    r.moving = false;
    return;
  }

  if (r.status === 'downed') {
    r.bleedTicks--;
    if (r.bleedTicks <= 0) {
      r.status = 'kia';
      return;
    }
  }

  stepMovement(ctx);
  stepWeapons(ctx);
  stepActions(ctx);

  r.prevFire = cmd.fire;
  r.prevUse = cmd.use;
  r.prevInteract = cmd.interact;
  r.prevFirstAid = cmd.firstAid;
  r.prevReload = cmd.reload;
}
